import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey";

var _canPropagate = /*#__PURE__*/_classPrivateFieldLooseKey("canPropagate");

var _target = /*#__PURE__*/_classPrivateFieldLooseKey("target");

var _type = /*#__PURE__*/_classPrivateFieldLooseKey("type");

/**
 * Polyfill for Event.
 * This file is necessary when trying to inherit from Event because
 * some environments doesn't have Event (old browser or Node.js).
 */
// Types
export default class Event {
  constructor(type) {
    Object.defineProperty(this, _canPropagate, {
      writable: true,
      value: true
    });
    Object.defineProperty(this, _target, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _type, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase(this, _type)[_type] = type;
  }

  get canPropagate() {
    return _classPrivateFieldLooseBase(this, _canPropagate)[_canPropagate];
  }

  stopImmediatePropagation() {
    _classPrivateFieldLooseBase(this, _canPropagate)[_canPropagate] = false;
  }

  get target() {
    return _classPrivateFieldLooseBase(this, _target)[_target];
  }

  set target(target) {
    if (_classPrivateFieldLooseBase(this, _target)[_target] === null) {
      _classPrivateFieldLooseBase(this, _target)[_target] = target;
    }
  }

  get type() {
    return _classPrivateFieldLooseBase(this, _type)[_type];
  }

}
//# sourceMappingURL=Event.js.map